<template>
    <div>
        <table class="table-default mt-5">
            <thead>
                <tr>
                    <th scope="col">{{$t('pages.settings.auction_timings.timings.periods')}}</th>
                    <th scope="col">{{$t('pages.settings.auction_timings.timings.live_show_start')}}</th>
                    <th scope="col">{{$t('pages.settings.auction_timings.timings.price_drop')}}</th>
                    <th scope="col">{{$t('pages.settings.auction_timings.timings.live_show_end')}}</th>
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-if="showTimes" v-for="(showTime, index) in showTimes" :key="index" class="hover:bg-gray-100">
                    <td>{{ index + 1 }}</td>
                    <td v-if="showTime.show === 1">{{ showTime.start | formatTime($t('locale.formatTimeTwelveHours'), timeZone, auctionTimeZone)}}</td>
                    <td v-if="showTime.show !== 1">--:--</td>
                    <td>{{ showTime.price_drop | formatTime($t('locale.formatTimeTwelveHours'), timeZone, auctionTimeZone)}}</td>
                    <td v-if="showTime.show === 1">{{ showTime.end | formatTime($t('locale.formatTimeTwelveHours'), timeZone, auctionTimeZone)}}</td>
                    <td v-if="showTime.show !== 1">--:--</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import Icon from "@/Shared/Icon";

export default {
    metaInfo: {title: 'Profile'},
    layout: Layout,
    components: {
        Icon
    },
    props: {
        timeZone : String,
        showTimes: Array,
        auctionTimeZone: String
    },
    methods: {
        auctionTimeZoneDescription(timeZone) {
            return timeZone === this.auctionTimeZone ? this.$t('pages.settings.auction_timings.timezone.auction_time') : '';
        },
        getSelectedTimeZoneName() {
            return this.timeZones[this.selectedTimezone];
        }
    }
}
</script>
